import React, { useState, useEffect, useCallback } from 'react';

const API = '/api';
function authHeaders() {
  const token = localStorage.getItem('lc_token');
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
}

const C = {
  grn: '#3B6D11', grnBg: '#EAF3DE',
  amb: '#854F0B', ambBg: '#FAEEDA',
  red: '#A32D2D', redBg: '#FCEBEB',
  acc: '#185FA5', accBg: '#E6F1FB',
  border: 'rgba(0,0,0,0.08)', bg: '#F2F0EB', card: '#fff',
  txt: '#1a1a1a', txt2: '#666'
};

function effColor(pct) { return pct >= 75 ? C.grn : pct >= 60 ? C.amb : C.red; }

function Badge({ children, color, bg }) {
  return <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 4, background: bg, color, whiteSpace: 'nowrap' }}>{children}</span>;
}

function DeltaBadge({ val }) {
  if (val === 0) return <Badge color={C.txt2} bg="#eee">±0%</Badge>;
  return val > 0
    ? <Badge color={C.grn} bg={C.grnBg}>+{val}%</Badge>
    : <Badge color={C.red} bg={C.redBg}>{val}%</Badge>;
}

function TierBadge({ tier }) {
  const map = { direct: [C.grn, C.grnBg, 'Direct'], fund: [C.amb, C.ambBg, 'Fund.'], any: [C.txt2, '#eee', 'Any'] };
  const [color, bg, label] = map[tier] || [C.txt2, '#eee', tier];
  return <Badge color={color} bg={bg}>{label}</Badge>;
}

function SuggestionCard({ sug, selected, onToggle }) {
  const { slot_from: sf, slot_to: st } = sug;
  return (
    <div onClick={onToggle} style={{
      background: C.card, borderRadius: 10, border: `1.5px solid ${selected ? C.acc : C.border}`,
      padding: '14px 16px', cursor: 'pointer',
      boxShadow: selected ? `0 0 0 2px ${C.accBg}` : '0 1px 4px rgba(0,0,0,0.04)',
      transition: 'all 0.15s'
    }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 18, height: 18, borderRadius: 4, border: `2px solid ${selected ? C.acc : C.border}`, background: selected ? C.acc : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {selected && <span style={{ color: '#fff', fontSize: 11, fontWeight: 800 }}>✓</span>}
          </div>
          <span style={{ fontSize: 11, fontWeight: 700, color: C.txt2, textTransform: 'uppercase' }}>Swap</span>
        </div>
        <div style={{ display: 'flex', gap: 6 }}>
          <span style={{ fontSize: 11, fontWeight: 700, color: effColor(sug.plant_eff_delta > 0 ? 80 : 50) }}>
            Plant +{sug.plant_eff_delta}%
          </span>
        </div>
      </div>

      {/* Two operator panels */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 32px 1fr', gap: 8, alignItems: 'center' }}>
        {/* Operator A */}
        <div style={{ background: C.bg, borderRadius: 7, padding: '10px 12px' }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: C.txt, marginBottom: 2 }}>{sf.emp_name}</div>
          <div style={{ fontSize: 10, color: C.txt2, marginBottom: 6 }}>{sf.emp_code} · Line {sf.line_number}</div>
          <div style={{ fontSize: 10, color: C.txt2, marginBottom: 4 }}>{sf.operation_name}</div>
          <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
            <Badge color={effColor(sf.current_skill_pct)} bg={sf.current_skill_pct >= 75 ? C.grnBg : sf.current_skill_pct >= 60 ? C.ambBg : C.redBg}>{Math.round(sf.current_skill_pct)}%</Badge>
            <span style={{ fontSize: 9, color: C.txt2 }}>→</span>
            <Badge color={effColor(sug.skill_after_from.pct)} bg={sug.skill_after_from.pct >= 75 ? C.grnBg : sug.skill_after_from.pct >= 60 ? C.ambBg : C.redBg}>{Math.round(sug.skill_after_from.pct)}%</Badge>
            <TierBadge tier={sug.skill_after_from.tier} />
          </div>
          <div style={{ marginTop: 6 }}><DeltaBadge val={sug.line_eff_delta_from} /></div>
        </div>

        {/* Arrow */}
        <div style={{ textAlign: 'center', fontSize: 18, color: C.txt2 }}>⇄</div>

        {/* Operator B */}
        <div style={{ background: C.bg, borderRadius: 7, padding: '10px 12px' }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: C.txt, marginBottom: 2 }}>{st.emp_name}</div>
          <div style={{ fontSize: 10, color: C.txt2, marginBottom: 6 }}>{st.emp_code} · Line {st.line_number}</div>
          <div style={{ fontSize: 10, color: C.txt2, marginBottom: 4 }}>{st.operation_name}</div>
          <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
            <Badge color={effColor(st.current_skill_pct)} bg={st.current_skill_pct >= 75 ? C.grnBg : st.current_skill_pct >= 60 ? C.ambBg : C.redBg}>{Math.round(st.current_skill_pct)}%</Badge>
            <span style={{ fontSize: 9, color: C.txt2 }}>→</span>
            <Badge color={effColor(sug.skill_after_to.pct)} bg={sug.skill_after_to.pct >= 75 ? C.grnBg : sug.skill_after_to.pct >= 60 ? C.ambBg : C.redBg}>{Math.round(sug.skill_after_to.pct)}%</Badge>
            <TierBadge tier={sug.skill_after_to.tier} />
          </div>
          <div style={{ marginTop: 6 }}><DeltaBadge val={sug.line_eff_delta_to} /></div>
        </div>
      </div>

      {/* Line efficiency summary */}
      <div style={{ display: 'flex', gap: 16, marginTop: 10, paddingTop: 10, borderTop: `0.5px solid ${C.border}` }}>
        <div style={{ fontSize: 10, color: C.txt2 }}>
          Line {sf.line_number}: <span style={{ fontWeight: 700, color: effColor(sug.base_eff_from) }}>{sug.base_eff_from}%</span>
          <span style={{ color: C.txt2 }}> → </span>
          <span style={{ fontWeight: 700, color: effColor(sug.new_eff_from) }}>{sug.new_eff_from}%</span>
        </div>
        <div style={{ fontSize: 10, color: C.txt2 }}>
          Line {st.line_number}: <span style={{ fontWeight: 700, color: effColor(sug.base_eff_to) }}>{sug.base_eff_to}%</span>
          <span style={{ color: C.txt2 }}> → </span>
          <span style={{ fontWeight: 700, color: effColor(sug.new_eff_to) }}>{sug.new_eff_to}%</span>
        </div>
      </div>
    </div>
  );
}

function PendingCard({ row, onReview }) {
  return (
    <div style={{ background: C.card, borderRadius: 10, border: `0.5px solid ${C.border}`, padding: '14px 16px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: C.txt }}>
          {row.emp_name} <span style={{ color: C.txt2, fontWeight: 400 }}>({row.emp_code})</span>
        </div>
        <Badge color={C.amb} bg={C.ambBg}>Pending</Badge>
      </div>
      <div style={{ fontSize: 11, color: C.txt2, marginBottom: 4 }}>
        Line {row.line_from} · {row.op_from_name} → Line {row.line_to} · {row.op_to_name}
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
        <span style={{ fontSize: 10, color: C.txt2 }}>Skill: {row.skill_pct_from}% → {row.skill_pct_to}%</span>
        <DeltaBadge val={parseFloat(row.plant_eff_delta)} />
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => onReview(row.id, 'accepted')} style={{
          flex: 1, padding: '6px 0', borderRadius: 6, border: 'none',
          background: C.grn, color: '#fff', fontSize: 12, fontWeight: 700, cursor: 'pointer'
        }}>✓ Accept</button>
        <button onClick={() => onReview(row.id, 'rejected')} style={{
          flex: 1, padding: '6px 0', borderRadius: 6, border: `1px solid ${C.border}`,
          background: '#fff', color: C.red, fontSize: 12, fontWeight: 700, cursor: 'pointer'
        }}>✕ Reject</button>
      </div>
    </div>
  );
}

export default function PlantOptimiser() {
  const [tab, setTab] = useState('run'); // 'run' | 'pending'
  const [factories, setFactories] = useState([]);
  const [selectedFactory, setSelectedFactory] = useState('');
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState(null);
  const [selected, setSelected] = useState(new Set());
  const [saving, setSaving] = useState(false);
  const [savedMsg, setSavedMsg] = useState('');
  const [pending, setPending] = useState([]);
  const [loadingPending, setLoadingPending] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const el = document.getElementById('lc-page-title');
    if (el) el.textContent = 'Plant Optimiser';
    fetch(`${API}/factories`, { headers: authHeaders() })
      .then(r => r.json()).then(d => { if (Array.isArray(d)) setFactories(d); }).catch(() => {});
  }, []);

  const loadPending = useCallback(() => {
    setLoadingPending(true);
    fetch(`${API}/plant-optimiser/pending`, { headers: authHeaders() })
      .then(r => r.json()).then(d => { setPending(Array.isArray(d) ? d : []); setLoadingPending(false); })
      .catch(() => setLoadingPending(false));
  }, []);

  useEffect(() => { if (tab === 'pending') loadPending(); }, [tab, loadPending]);

  const handleRun = async () => {
    setRunning(true); setResult(null); setSelected(new Set()); setError('');
    const url = selectedFactory
      ? `${API}/plant-optimiser/run?factory_id=${selectedFactory}`
      : `${API}/plant-optimiser/run`;
    const r = await fetch(url, { headers: authHeaders() });
    const d = await r.json();
    if (d.error) { setError(d.error); setRunning(false); return; }
    setResult(d);
    setRunning(false);
  };

  const toggleSelect = (idx) => {
    setSelected(prev => {
      const n = new Set(prev);
      n.has(idx) ? n.delete(idx) : n.add(idx);
      return n;
    });
  };

  const selectAll = () => setSelected(new Set(result.suggestions.map((_, i) => i)));
  const clearAll = () => setSelected(new Set());

  const handleSave = async () => {
    const toSave = result.suggestions.filter((_, i) => selected.has(i));
    if (!toSave.length) return;
    setSaving(true);
    const r = await fetch(`${API}/plant-optimiser/save-session`, {
      method: 'POST', headers: authHeaders(),
      body: JSON.stringify({ suggestions: toSave })
    });
    const d = await r.json();
    if (r.ok) {
      setSavedMsg(`${d.saved} suggestion${d.saved !== 1 ? 's' : ''} sent for approval`);
      setSelected(new Set()); setResult(null);
      setTimeout(() => setSavedMsg(''), 4000);
    } else { setError(d.error); }
    setSaving(false);
  };

  const handleReview = async (id, action) => {
    const r = await fetch(`${API}/plant-optimiser/${id}/review`, {
      method: 'POST', headers: authHeaders(),
      body: JSON.stringify({ action })
    });
    if (r.ok) loadPending();
  };

  return (
    <div style={{ background: C.bg, minHeight: '100vh', padding: 24, fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif' }}>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
        <div>
          <div style={{ fontSize: 18, fontWeight: 800, color: C.txt }}>Plant Optimiser</div>
          <div style={{ fontSize: 12, color: C.txt2, marginTop: 2 }}>Cross-line operator swap suggestions to maximise plant efficiency</div>
        </div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <select value={selectedFactory} onChange={e => setSelectedFactory(e.target.value)}
            style={{ padding: '6px 12px', borderRadius: 6, border: `0.5px solid ${C.border}`, background: C.card, fontSize: 12, cursor: 'pointer' }}>
            <option value="">All factories</option>
            {factories.map(f => <option key={f.id} value={f.id}>{f.name}</option>)}
          </select>
          {tab === 'run' && (
            <button onClick={handleRun} disabled={running} style={{
              padding: '7px 18px', borderRadius: 7, border: 'none',
              background: running ? C.border : C.acc, color: '#fff',
              fontSize: 13, fontWeight: 700, cursor: running ? 'wait' : 'pointer'
            }}>
              {running ? 'Analysing…' : '▶ Run Optimiser'}
            </button>
          )}
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 20, borderBottom: `1px solid ${C.border}`, paddingBottom: 0 }}>
        {[['run', 'Suggestions'], ['pending', `Pending Approval${pending.length ? ` (${pending.length})` : ''}`]].map(([key, label]) => (
          <button key={key} onClick={() => setTab(key)} style={{
            padding: '8px 18px', borderRadius: '6px 6px 0 0', border: 'none',
            background: tab === key ? C.card : 'transparent',
            borderBottom: tab === key ? `2px solid ${C.acc}` : '2px solid transparent',
            color: tab === key ? C.acc : C.txt2, fontSize: 13, fontWeight: 700, cursor: 'pointer'
          }}>{label}</button>
        ))}
      </div>

      {error && (
        <div style={{ background: C.redBg, border: `1px solid ${C.red}`, borderRadius: 7, padding: '10px 14px', marginBottom: 16, fontSize: 13, color: C.red }}>{error}</div>
      )}
      {savedMsg && (
        <div style={{ background: C.grnBg, border: `1px solid ${C.grn}`, borderRadius: 7, padding: '10px 14px', marginBottom: 16, fontSize: 13, color: C.grn, fontWeight: 600 }}>✓ {savedMsg}</div>
      )}

      {/* ── Run tab ── */}
      {tab === 'run' && (
        <>
          {!result && !running && (
            <div style={{ textAlign: 'center', padding: '60px 0', color: C.txt2, fontSize: 14 }}>
              Click "Run Optimiser" to analyse cross-line swap opportunities.
            </div>
          )}
          {running && (
            <div style={{ textAlign: 'center', padding: '60px 0', color: C.txt2, fontSize: 14 }}>
              Analysing all operator combinations across active lines…
            </div>
          )}
          {result && (
            <>
              {/* Summary bar */}
              <div style={{ display: 'flex', gap: 12, marginBottom: 20, background: C.card, borderRadius: 10, padding: '14px 18px', border: `0.5px solid ${C.border}`, alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 10, color: C.txt2, fontWeight: 600, textTransform: 'uppercase', marginBottom: 4 }}>Current plant DB Eff</div>
                  <div style={{ fontSize: 24, fontWeight: 800, color: effColor(result.baseline_plant_efficiency) }}>{result.baseline_plant_efficiency}%</div>
                </div>
                <div style={{ fontSize: 24, color: C.txt2 }}>→</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 10, color: C.txt2, fontWeight: 600, textTransform: 'uppercase', marginBottom: 4 }}>Projected (if all accepted)</div>
                  <div style={{ fontSize: 24, fontWeight: 800, color: effColor(result.projected_plant_efficiency) }}>{result.projected_plant_efficiency}%</div>
                </div>
                <div style={{ flex: 1, textAlign: 'right' }}>
                  <div style={{ fontSize: 10, color: C.txt2, fontWeight: 600, textTransform: 'uppercase', marginBottom: 4 }}>Suggestions</div>
                  <div style={{ fontSize: 24, fontWeight: 800, color: C.acc }}>{result.suggestions.length}</div>
                </div>
              </div>

              {result.suggestions.length === 0 && (
                <div style={{ textAlign: 'center', padding: 40, color: C.txt2, fontSize: 13 }}>
                  No beneficial swaps found. Plant is already well-optimised.
                </div>
              )}

              {result.suggestions.length > 0 && (
                <>
                  {/* Toolbar */}
                  <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 14 }}>
                    <span style={{ fontSize: 12, color: C.txt2 }}>{selected.size} of {result.suggestions.length} selected</span>
                    <button onClick={selectAll} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 5, border: `0.5px solid ${C.border}`, background: C.card, cursor: 'pointer', color: C.acc, fontWeight: 600 }}>Select all</button>
                    <button onClick={clearAll} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 5, border: `0.5px solid ${C.border}`, background: C.card, cursor: 'pointer', color: C.txt2 }}>Clear</button>
                    <div style={{ flex: 1 }} />
                    <button onClick={handleSave} disabled={!selected.size || saving} style={{
                      padding: '7px 20px', borderRadius: 7, border: 'none',
                      background: selected.size ? C.acc : C.border,
                      color: '#fff', fontSize: 13, fontWeight: 700,
                      cursor: selected.size ? 'pointer' : 'not-allowed'
                    }}>
                      {saving ? 'Sending…' : `Send ${selected.size} for Approval`}
                    </button>
                  </div>

                  {/* Cards */}
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(420px, 1fr))', gap: 12 }}>
                    {result.suggestions.map((sug, i) => (
                      <SuggestionCard key={i} sug={sug} selected={selected.has(i)} onToggle={() => toggleSelect(i)} />
                    ))}
                  </div>
                </>
              )}
            </>
          )}
        </>
      )}

      {/* ── Pending tab ── */}
      {tab === 'pending' && (
        <>
          {loadingPending && <div style={{ textAlign: 'center', padding: 40, color: C.txt2 }}>Loading…</div>}
          {!loadingPending && pending.length === 0 && (
            <div style={{ textAlign: 'center', padding: 60, color: C.txt2, fontSize: 14 }}>No pending suggestions.</div>
          )}
          {!loadingPending && pending.length > 0 && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: 12 }}>
              {pending.map(row => <PendingCard key={row.id} row={row} onReview={handleReview} />)}
            </div>
          )}
        </>
      )}
    </div>
  );
}
